// extracted by mini-css-extract-plugin
export var markdown = "_u2-0";
export var tableWrapper = "_u2-1";